import {
  SprintUserCommitment,
  SprintUserCommitmentFromJSON,
} from "./SprintUserCommitment";

export interface SprintUserSummary {
  sprintId: number;
  userDisplayName: string;
  userSprintAvailability: number;
  userSprintCommitment: SprintUserCommitment;
  userSprintSpentTime: number;
}

export function SprintUserSummaryFromJSON(
  json: Record<string, any>,
): SprintUserSummary {
  return {
    sprintId: json["sprintId"],
    userDisplayName: json["userDisplayName"],
    userSprintAvailability: json["userSprintAvailability"],
    userSprintCommitment: SprintUserCommitmentFromJSON(
      json["userSprintCommitment"] || {},
    ),
    userSprintSpentTime: json["userSprintSpentTime"],
  };
}
